// extracted by mini-css-extract-plugin
export default {"container":"ZZ-z","list":"_Z-z"};